// import otpAvatar from "./otp.png"
import otpDesktop from "./otp.svg"
import otpMobile from "./otpMobile.svg"
import optsvg from "./OTP_updated.svg"


const signupPageAssets = {
    // otpAvatar,
    otpDesktop,
    otpMobile,
    optsvg    
}

export default signupPageAssets